var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMongodb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#FFD15C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.027 18.3512C50.8712 14.5979 48.1968 10.8445 47.6084 10.0402C47.555 9.9866 47.448 9.9866 47.3945 10.0402C46.8596 10.8445 44.1317 14.5979 40.976 18.3512C14.0182 52.8284 45.2015 76.0992 45.2015 76.0992L45.4689 76.26C45.6829 79.8525 46.2713 85 46.2713 85H47.448H48.6247C48.6247 85 49.2131 79.8525 49.427 76.26L49.6945 76.0456C49.8014 76.0992 80.9848 52.8284 54.027 18.3512ZM47.5015 75.563C47.5015 75.563 46.1108 74.3834 45.7364 73.7399V73.6863L47.448 36.1528C47.448 36.0456 47.6084 36.0456 47.6084 36.1528L49.32 73.6863V73.7399C48.9456 74.3834 47.5015 75.563 47.5015 75.563Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.d54efd7bb2251070c87e8176d398b0c5.svg";
export { ForwardRef as ReactComponent };